<template>
  <SharedNavigation>
    <b-nav-item
      :to="{ name: 'dashboard' }"
      class="d-none d-lg-flex"
    >
      <span>Dashboard</span>
    </b-nav-item>

    <b-nav-item
      :to="{ name: 'planning' }"
      class="d-none d-lg-flex"
      :active="isBookingsRoute()"
    >
      <span>Planning</span>
    </b-nav-item>

    <b-nav-item-dropdown
      class="d-none d-lg-flex"
      text="Profiles"
      :toggle-class="{ active: isChildrenRoute() }"
    >
      <b-dropdown-item
        :to="{ name: 'children' }"
        class=""
      >
        Children
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'children-reports' }"
        class=""
      >
        Reports
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'children-requests' }"
        class=""
      >
        Requests
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'children-carers' }"
        class=""
      >
        Carers
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <b-nav-item-dropdown
      class="d-none d-lg-flex"
      text="Performance"
      :toggle-class="{ active: isPerformanceRoute() }"
    >
      <b-dropdown-item
        :to="{ name: 'service-insights-customers' }"
        class=""
      >
        Insights
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'service-performance-service' }"
        class=""
      >
        Service Performance
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'development-diary' }"
        class=""
      >
        Development Diary
      </b-dropdown-item>
    </b-nav-item-dropdown>
  
    <b-nav-item-dropdown
      class="d-none d-lg-flex"
      text="Team"
      :toggle-class="{ active: isTeamRoute() }"
    >
      <b-dropdown-item
        :to="{ name: 'staff-list' }"
        class=""
      >
        Staff
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'team' }"
        class=""
      >
        Rotas
      </b-dropdown-item>

      <b-dropdown-item
        :to="{ name: 'templates' }"
        class=""
      >
        Rota Templates
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <template #search>
      <HeaderSearch
        @search="search($event)"
      />
    </template>

    <div />
  </SharedNavigation>
</template>
<script>
import SharedNavigation from '@/core/layouts/global-layout/components/user-navigation/SharedNavigation'
import { isBookingsRoute, isChildrenRoute, isPerformanceRoute, isTeamRoute } from '@/core/router/utils'
import HeaderSearch from '@/core/layouts/global-layout/components/nav-items/HeaderSearch'

export default {
  components: {
    SharedNavigation,
    HeaderSearch
  },

  methods: {
    isBookingsRoute() {
      return isBookingsRoute(this.$route.name)
    },

    isChildrenRoute() {
      return isChildrenRoute(this.$route.name)
    },

    isPerformanceRoute() {
      return isPerformanceRoute(this.$route.name)
    },

    isTeamRoute() {
      return isTeamRoute(this.$route.name)
    },

    search(event) {
      this.$emit('search', event)
    },
  }
}

</script>